import StringUtils from 'lib/StringUtils';
import { DealStatus, DealType, FinanceDefaultCalculation } from 'utils/enum/DealEnum';
import {
    CreateDealFinanceSchema,
    CreateDealCashSchema,
    BHPHSchema,
    FinanceSchema,
    CashSchema,
    WholesaleSchema,
    LeaseSchema,
    CreateDealLeaseSchema,
    DraftSchema,
    CreateDealDraftSchema,
} from 'utils/schema/deal/DealStructure';
import { ClientId } from 'utils/enum/Core';

export default class DealUtils {
    // TODO: When all dealTypes are allowed, return the changes to how they are in this committee for this function
    // https://bitbucket.org/automatrix/crm-web/commits/b4725159f7c804a66ce2126021126c5e724841de
    static getDealType() {
        return [
            {
                value: DealType.CASH,
                label: DealType.CASH,
            },
            {
                value: DealType.FINANCE,
                label: DealType.FINANCE,
            },
            {
                value: DealType.WHOLESALE,
                label: DealType.WHOLESALE,
            },
            {
                value: DealType.DRAFT,
                label: DealType.DRAFT,
            },
            {
                value: DealType.BHPH,
                label: DealType.BHPH,
            },
            {
                value: DealType.LEASE,
                label: DealType.LEASE,
            },
            {
                value: DealType.LHPH,
                label: DealType.LHPH,
            },
        ];
    }

    static getSchemaByDealType(dealType) {
        switch (dealType) {
        case DealType.BHPH:
            return BHPHSchema;
        case DealType.FINANCE:
            return FinanceSchema;
        case DealType.DRAFT:
            return DraftSchema;
        case DealType.CASH:
            return CashSchema;
        case DealType.WHOLESALE:
            return WholesaleSchema;
        case DealType.LEASE:
        case DealType.LHPH:
            return LeaseSchema;
        default:
            return null;
        }
    }

    static getCreateSchemaByDealType(dealType) {
        switch (dealType) {
        case DealType.BHPH:
        case DealType.FINANCE:
        default:
            return CreateDealFinanceSchema;
        case DealType.CASH:
        case DealType.WHOLESALE:
            return CreateDealCashSchema(dealType);
        case DealType.DRAFT:
            return CreateDealDraftSchema;
        case DealType.LEASE:
        case DealType.LHPH:
            return CreateDealLeaseSchema;
        }
    }

    static getDealTypeByType(dealType) {
        if (typeof dealType === 'string' && !StringUtils.isEmpty(dealType)) {
            const records = this.getDealType();
            return records.find((item) => item.value?.toUpperCase() === dealType.toUpperCase()) || null;
        }

        return null;
    }

    static clientIdIsWeb(clientId = '') {
        return clientId?.toUpperCase() === ClientId.WEB.toUpperCase();
    }

    static getFinanceDefaultCalculation() {
        const defaultCalculationOptions = Object.keys(FinanceDefaultCalculation)
            .map((key) => ({ value: key.toLowerCase(), label: FinanceDefaultCalculation[key] }));

        return defaultCalculationOptions;
    }

    static allowEditDeal(status) {
        const dealStatuses = [DealStatus.QUOTE.toLowerCase(), DealStatus.FNI.toLowerCase()];
        return dealStatuses.includes(status?.toLowerCase());
    }
}
